import { Navigate, type RouteObject } from 'react-router-dom';
import { AssistantPage } from './components/features/assistant/AssistantPage';
import { LoginPage } from './components/features/auth/LoginPage';
import { UnauthorizedPage } from './components/features/auth/UnauthorizedPage';
import { CatalogPage } from './components/features/catalog/CatalogPage';
import { ClientDetailPage } from './components/features/clients/ClientDetailPage';
import { ClientsListPage } from './components/features/clients/ClientsListPage';
import { DashboardPage } from './components/features/dashboard/DashboardPage';
import { OfferBuilderPage } from './components/features/offers/OfferBuilderPage';
import { OffersListPage } from './components/features/offers/OffersListPage';
import { OrdersListPage } from './components/features/orders/OrdersListPage';
import { AuditLogPage } from './components/features/settings/AuditLogPage';
import { ExchangeRatePage } from './components/features/settings/ExchangeRatePage';
import { SettingsPage } from './components/features/settings/SettingsPage';
import { AppLayout } from './components/layout/AppLayout';
import { ProtectedRoute } from './components/layout/ProtectedRoute';
import { ROUTES } from './config/routes';
import { UserRole } from './models/enums';

export const appRoutes: RouteObject[] = [
  { path: ROUTES.LOGIN, element: <LoginPage /> },
  { path: ROUTES.UNAUTHORIZED, element: <UnauthorizedPage /> },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <AppLayout />
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <Navigate to={ROUTES.DASHBOARD} replace /> },
      { path: ROUTES.ASSISTANT.slice(1), element: <AssistantPage /> },
      { path: ROUTES.DASHBOARD.slice(1), element: <DashboardPage /> },
      { path: ROUTES.CLIENTS.slice(1), element: <ClientsListPage /> },
      { path: ROUTES.CLIENT_DETAIL.slice(1), element: <ClientDetailPage /> },
      { path: ROUTES.ORDERS.slice(1), element: <OrdersListPage /> },
      { path: ROUTES.CATALOG.slice(1), element: <CatalogPage /> },
      { path: ROUTES.OFFERS.slice(1), element: <OffersListPage /> },
      { path: ROUTES.OFFER_NEW.slice(1), element: <OfferBuilderPage /> },
      { path: ROUTES.OFFER_EDIT.slice(1), element: <OfferBuilderPage /> },
      { path: ROUTES.SETTINGS.slice(1), element: <ProtectedRoute allowedRoles={[UserRole.Admin]}><SettingsPage /></ProtectedRoute> },
      { path: ROUTES.SETTINGS_EXCHANGE_RATE.slice(1), element: <ProtectedRoute allowedRoles={[UserRole.Admin]}><ExchangeRatePage /></ProtectedRoute> },
      { path: ROUTES.SETTINGS_AUDIT.slice(1), element: <ProtectedRoute allowedRoles={[UserRole.Admin]}><AuditLogPage /></ProtectedRoute> },
    ],
  },
];
